// extracted by mini-css-extract-plugin
export default {"container":"card-subtitle_container__kQDPZ"};